import { createDynamicThunk } from ".";

export const getDepartmentListThunk = createDynamicThunk({
  typePrefix: "departments/getDepartmentListThunk",
  useHandleSearch: true,
});

export const addDepartmentThunk = createDynamicThunk({
  typePrefix: "departments/addDepartmentThunk",
  endpoint: "/departments",
  method: "POST",
  refreshList: true,
  listThunk: getDepartmentListThunk,
});

export const editDepartmentThunk = createDynamicThunk({
  typePrefix: "departments/editDepartmentThunk",
  endpoint: "/departments",
  method: "PUT",
  refreshList: true,
  listThunk: getDepartmentListThunk,
  transformResponse: (response) => response,
});

export const deleteDepartmentThunk = createDynamicThunk({
  typePrefix: "/deleteDepartmentThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getDepartmentListThunk,
});
